import { render, staticRenderFns } from "./metrics_trend_sparkline.vue?vue&type=template&id=06ca0cde&scoped=true&"
import script from "./metrics_trend_sparkline.vue?vue&type=script&lang=js&"
export * from "./metrics_trend_sparkline.vue?vue&type=script&lang=js&"
import style0 from "./metrics_trend_sparkline.vue?vue&type=style&index=0&id=06ca0cde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca0cde",
  null
  
)

export default component.exports